<script setup lang="ts">
const model = defineModel<string>({ default: '' });
const props = withDefaults(
  defineProps<{
    invalid?: boolean;
    huge?: boolean;
    type?: string;
  }>(),
  {
    type: 'text',
  },
);

function allowEagerInputOnMobile(event: Event) {
  const input = event.target as HTMLInputElement;
  // @ts-expect-error: "composing" is not a standard property
  input.composing = false; // Prevents issues with IME input
}
</script>

<template>
  <input
    v-model="model"
    class="ui-form-input"
    :class="{
      'text-4xl': props.huge,
      'animate-wiggle outline-state-error focus:outline-state-error': props.invalid,
    }"
    :type="props.type"
    @input="allowEagerInputOnMobile"
  />
</template>
